import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { toast } from "vanilla-sonner";

function SlideToElement() {
  async function onSlideTo(this: HTMLElement) {
    const slideToValue = this.getAttribute("slide-to");
    if (!slideToValue) {
      return;
    }
    const target = document.querySelector<HTMLElement>(slideToValue);
    if (!target) {
      return;
    }
    gsap.to(window, { duration: 1, scrollTo: target, ease: "expo" });
  }
  document.querySelectorAll<HTMLElement>("[slide-to]").forEach((element) => {
    element.addEventListener("click", onSlideTo);
  });
}

function MobileMenu() {
  const toggleButton = document.getElementById("mobile-menu-toggle");
  const menu = document.getElementById("main-menu");
  const backdrop = document.getElementById("mobile-menu-backdrop");

  if (!toggleButton || !menu || !backdrop) {
    return;
  }

  const openMenu = () => {
    toggleButton.setAttribute("aria-expanded", "true");
    menu.classList.remove("opacity-0", "-translate-y-2", "pointer-events-none");
    menu.classList.add("opacity-100", "translate-y-0", "pointer-events-auto");
    backdrop.classList.remove("opacity-0", "pointer-events-none");
    backdrop.classList.add("opacity-100", "pointer-events-auto");
  };

  const closeMenu = () => {
    toggleButton.setAttribute("aria-expanded", "false");
    menu.classList.remove("opacity-100", "translate-y-0", "pointer-events-auto");
    menu.classList.add("opacity-0", "-translate-y-2", "pointer-events-none");
    backdrop.classList.remove("opacity-100", "pointer-events-auto");
    backdrop.classList.add("opacity-0", "pointer-events-none");
  };

  if (window.innerWidth >= 768) {
    closeMenu();
  }

  toggleButton.addEventListener("click", () => {
    const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closeMenu();
      return;
    }

    openMenu();
  });

  backdrop.addEventListener("click", closeMenu);

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 768) {
      closeMenu();
    }
  });
}

function TransparentMenu() {
  const header = document.getElementById("header") as HTMLDivElement;
  if (!header || header.classList.contains("header-kitazato")) {
    return;
  }

  ScrollTrigger.create({
    trigger: header,
    start: "top top",
    end: "=+1",
    onLeave: () => {
      header.classList.add("header-white", "header-sm");
    },
    onEnterBack: () => {
      header.classList.remove("header-white", "header-sm");
    },
  });
}

function CopyToClipboard() {
  async function onCopy(this: HTMLElement) {
    const copyText = this.getAttribute("copy-to-clipboard");
    const alertMessageText = this.getAttribute("copy-to-clipboard-alert-message");
    if (copyText) {
      try {
        await navigator.clipboard.writeText(copyText);
        toast.success(alertMessageText || "Texto copiado");
      } catch (_: unknown) {
        //
      }
    }
  }
  document.querySelectorAll<HTMLElement>("[copy-to-clipboard]").forEach((element) => {
    console.log(element);
    element.addEventListener("click", onCopy);
  });
}

export default function AllPages() {
  MobileMenu();
  SlideToElement();
  TransparentMenu();
  CopyToClipboard();
}
